import React from "react";
import { Row, Col, Spinner } from "react-bootstrap";
const Loading = () => {
  return (
    <Row>
      <Col className="d-flex align-items-center justify-content-center">
        <Spinner animation="grow" variant="primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Col>
    </Row>
  );
};

export default Loading;
